import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Title from '@zenbusiness/common-components/Title';
import { isObject } from 'lodash';
import PropTypes from 'prop-types';

import { Box } from '@mui/system';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { options } from '../DynamicTypography';

const TitleWrapper = superstyled({
  tag: Box,
  styles: {
    display: 'flex',
    alignContent: 'start',
    alignItems: 'start',
    width: '100%',
    marginBottom: '1.5rem'
  }
});

const StyleLessonTitle = superstyled({
  tag: Title,
  props: { level: 1, variant: 'md-alt' },
  styles: ({ theme }) => ({
    fontSize: '1.75rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '2.25rem'
    }
  })
});
const LessonTitle = ({ title, className }) => (
  <TitleWrapper className={className}>
    <StyleLessonTitle>
      {isObject(title) ? documentToReactComponents(title, options) : title}
    </StyleLessonTitle>
  </TitleWrapper>
);

LessonTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

LessonTitle.defaultProps = {
  title: null
};

export default LessonTitle;
